import { DropmenuWrap } from './style'

const DropdownSubMenu = ({ children }) => {
  return <DropmenuWrap>{children}</DropmenuWrap>
}

export default DropdownSubMenu
